import { styled } from '@mui/material/styles'
import { Box, Button, Typography } from '@mui/material'

export const StyledContainer = styled(Box)({
  padding: '24px',
  color: 'white',
  backgroundColor: '#0d0d0d',
})

// Cards UI section
export const FilterContainer = styled(Box)({
  display: 'flex',
  gap: '12px',
  padding: '20px',
  justifyContent: 'center',
})

export const FilterButton = styled(Button)({
  padding: '6px 11px',
  borderRadius: '14.5px',
  backgroundColor: '#251e0f',
  fontFamily: 'Alexandria',
  fontWeight: '400',
  fontSize: '13px',
  lineHeight: '15.85px',
  letterSpacing: '1.63px',
  textAlign: 'center',
  color: '#feb820',
  opacity: '1',
  textTransform: 'uppercase',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
})

export const CommentCard = styled(Box)({
  backgroundColor: '#ffffff',
  borderRadius: '16px',
  marginBottom: '16px',
  overflow: 'hidden',
  width: '701px',
  '@media (max-width: 1024px)': {
    width: '100%',
  },
})

export const CommentHeader = styled(Box)({
  display: 'flex',
  padding: '16px',
  gap: '12px',
  alignItems: 'flex-start',
})

export const ProfileImage = styled('img')({
  width: '47px',
  height: '47px',
  borderRadius: '50%',
})

export const CommentContent = styled(Box)({
  flex: 1,
})

export const UserHandle = styled(Typography)({
  color: '#e75454',
  fontSize: '13px',
  fontWeight: 700,
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  '& .platform-icon': {
    width: '14px',
    height: '14px',
  },
})

export const TimeStamp = styled(Typography)({
  color: '#797979',
  fontSize: '13px',
  letterSpacing: '1.63px',
})

export const CommentText = styled(Typography)({
  color: '#000000',
  fontSize: '14px',
  lineHeight: '1.4',
  letterSpacing: '1.63px',
  marginLeft: '27px',
})

export const ReplySection = styled(Box)({
  backgroundColor: '#eeeeee',
  position: 'relative',
  padding: '32px 16px',
})

export const RepliedBadge = styled(Box)({
  color: '#28a745',
  fontSize: '14px',
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  position: 'absolute',
  right: '16px',
  top: '16px',
  '& .check-icon': {
    width: '16px',
    height: '16px',
  },
})

export const ReplyButton = styled(Button)({
  backgroundColor: '#000000',
  color: '#ffffff',
  borderRadius: '50px',
  padding: '2px 34px',
  fontSize: '17px',
  fontWeight: 400,
  textTransform: 'uppercase',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  '&:hover': {
    backgroundColor: '#333333',
  },
  '&.replied': {
    backgroundColor: 'transparent',
    color: '#00954b',
    fontWeight: 700,
    fontSize: '13px',
    letterSpacing: '1.63px',
    fontFamily: 'Albert Sans',
    boxShadow: 'none',
  },
  '& img': {
    width: '13px',
    height: '11px',
    objectFit: 'contain',
  },
})

export const ReplyIcon = styled('img')({
  width: '13px',
  height: '11px',
  objectFit: 'contain',
})
